import { createApp } from 'vue'
import { createBootstrap } from 'bootstrap-vue-next'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'
import { i18n } from '@/i18n'
import { router } from '@/router'
import { store } from '@/store'
import { installaxios } from '@/plugins/axios'
import App from '@/App.vue'

const app = createApp(App)
app.use(store)
app.use(router)
app.use(i18n)
app.use(installaxios)
app.use(createBootstrap())
app.mount('#app')
